import { takeLatest } from "redux-saga/effects"

import {
  apiGeneratorBase,
  apiGeneratorBaseWithOnSuccess,
  apiGeneratorDelete,
  apiGeneratorDeleteWithOnSuccess
} from "../../Utils/saga"
import Creators, { BusinessAccountsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getStatisticsAdminActions: {
    request: Creators.getStatisticsAdminRequest,
    success: Creators.getStatisticsAdminSuccess,
    errors: Creators.getStatisticsAdminFailure
  },
  getBusinessAccountsFilterOptionsActions: {
    request: Creators.getBusinessAccountsFilterOptionsRequest,
    success: Creators.getBusinessAccountsFilterOptionsSuccess,
    errors: Creators.getBusinessAccountsFilterOptionsFailure
  },
  getAdminBusinessAccountsActions: {
    request: Creators.getAdminBusinessAccountsRequest,
    success: Creators.getAdminBusinessAccountsSuccess,
    errors: Creators.businessAccountsFailure
  },
  deleteUserBusinessAccountActions: {
    request: Creators.deleteUserBusinessAccountRequest,
    success: Creators.deleteUserBusinessAccountSuccess,
    errors: Creators.businessAccountsFailure,
    extraAction: [Creators.getStatisticsAdminRequest]
  },
  getBusinessAccountsExportActions: {
    request: Creators.getBusinessAccountsExportRequest,
    success: Creators.getBusinessAccountsExportSuccess,
    errors: Creators.getBusinessAccountsExportFailure
    //downloadFile: true,
  },
  getAlertsChartActions: {
    request: Creators.getAlertsChartRequest,
    success: Creators.getAlertsChartSuccess,
    errors: Creators.getAlertsChartFailure
  },
  getBaCommentDataActions: {
    request: Creators.getBaCommentDataRequest,
    success: Creators.getBaCommentDataSuccess,
    errors: Creators.businessAccountsFailure
  },
  saveBaCommentActions: {
    request: Creators.saveBaCommentRequest,
    success: Creators.saveBaCommentSuccess,
    errors: Creators.businessAccountsFailure
  },
  deleteBaCommentActions: {
    request: Creators.deleteBaCommentRequest,
    success: Creators.deleteBaCommentSuccess,
    errors: Creators.businessAccountsFailure
  },
  deleteBaCommentAttachmentActions: {
    request: Creators.deleteBaCommentAttachmentRequest,
    success: Creators.deleteBaCommentAttachmentSuccess,
    errors: Creators.deleteBaCommentAttachmentFailure
  }
}

const eventsOptions = {
  [constants.GET_STATISTICS_ADMIN_REQUEST]: {
    api: services.getStatisticsAdmin,
    actions: actions.getStatisticsAdminActions
  },
  [constants.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_REQUEST]: {
    api: services.getBusinessAccountsFilterOptions,
    actions: actions.getBusinessAccountsFilterOptionsActions
  },
  [constants.GET_ADMIN_BUSINESS_ACCOUNTS_REQUEST]: {
    api: services.getAdminBusinessAccounts,
    actions: actions.getAdminBusinessAccountsActions
  },
  [constants.DELETE_USER_BUSINESS_ACCOUNT_REQUEST]: {
    api: services.deleteUserBusinessAccount,
    actions: actions.deleteUserBusinessAccountActions
  },
  [constants.GET_BUSINESS_ACCOUNTS_EXPORT_REQUEST]: {
    api: services.getBusinessAccountsExport,
    actions: actions.getBusinessAccountsExportActions
  },
  [constants.GET_ALERTS_CHART_REQUEST]: {
    api: services.getAlertsChart,
    actions: actions.getAlertsChartActions
  },
  [constants.GET_BA_COMMENT_DATA_REQUEST]: {
    api: services.getBaCommentData,
    actions: actions.getBaCommentDataActions
  },
  [constants.SAVE_BA_COMMENT_REQUEST]: {
    api: services.saveBaComment,
    actions: actions.saveBaCommentActions
  },
  [constants.DELETE_BA_COMMENT_REQUEST]: {
    api: services.deleteBaComment,
    actions: actions.deleteBaCommentActions
  },
  [constants.DELETE_BA_COMMENT_ATTACHMENT_REQUEST]: {
    api: services.deleteBaCommentAttachment,
    actions: actions.deleteBaCommentAttachmentActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_STATISTICS_ADMIN_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_STATISTICS_ADMIN_REQUEST])
  )
  yield takeLatest(constants.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_BUSINESS_ACCOUNTS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_BUSINESS_ACCOUNTS_REQUEST])
  )
  yield takeLatest(constants.GET_BUSINESS_ACCOUNTS_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BUSINESS_ACCOUNTS_EXPORT_REQUEST])
  )
  yield takeLatest(constants.GET_ALERTS_CHART_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ALERTS_CHART_REQUEST])
  )
  yield takeLatest(constants.DELETE_USER_BUSINESS_ACCOUNT_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_USER_BUSINESS_ACCOUNT_REQUEST])
  )
  yield takeLatest(constants.GET_BA_COMMENT_DATA_REQUEST, (action) =>
    apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.GET_BA_COMMENT_DATA_REQUEST])
  )
  yield takeLatest(constants.SAVE_BA_COMMENT_REQUEST, (action) =>
    apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.SAVE_BA_COMMENT_REQUEST])
  )
  yield takeLatest(constants.DELETE_BA_COMMENT_REQUEST, (action) =>
    apiGeneratorDeleteWithOnSuccess(action, eventsOptions[constants.DELETE_BA_COMMENT_REQUEST])
  )
  yield takeLatest(constants.DELETE_BA_COMMENT_ATTACHMENT_REQUEST, (action) =>
    apiGeneratorDeleteWithOnSuccess(
      action,
      eventsOptions[constants.DELETE_BA_COMMENT_ATTACHMENT_REQUEST]
    )
  )
}
